import { useToastStore } from '@/stores/toastStore';

export const useToast = () => {
  const showToast = useToastStore((state) => state.showToast);
  const hideToast = useToastStore((state) => state.hideToast);

  return {
    showToast,
    hideToast,
  };
};


